import { render } from "./CreateTemplateInstructions.vue?vue&type=template&id=2c507319&scoped=true"
import script from "./CreateTemplateInstructions.vue?vue&type=script&lang=ts"
export * from "./CreateTemplateInstructions.vue?vue&type=script&lang=ts"

import "./CreateTemplateInstructions.vue?vue&type=style&index=0&id=2c507319&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2c507319"

export default script